import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("guzz_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem("guzz_token");
        localStorage.removeItem("guzz_email");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const imageUrl = (storagePath) => `${API}/images/${storagePath}`;

export const formatPrice = (v) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
    useGrouping: "always",
  }).format(v);

export const formatKm = (v) =>
  `${new Intl.NumberFormat("it-IT").format(v)} km`;
